export default function getResource(label, vars = []) {
    const resources = {
        errorDescriptionLine1: 'Sorry, the page you’re looking for cannot be found',
        errorDescriptionLine2: 'Please check back soon.'
    };

    return resources[label];
}
